/**
 * Default value to indent the child of tree item
 */
export var DEFAULT_TREE_CHILD_INDENT = 24;
/**
 * This is an estimated height for each list item
 * We are calculating the height after render dynamically,
 * providing an estimated height is helpful based on react-virtual documentation
 */
export var ESTIMATED_LIST_ITEM_HEIGHT = 32;
/**
 * Number of items that need to be loaded in DOM above and below the currently
 * visible items
 */
export var OVER_SCAN_SIZE = 10;
//# sourceMappingURL=constants.js.map